import superagent from 'superagent';

const API_URL = process.env.VUE_APP_API_ROOT;

function handleError(err) {
  return err;
}

const requests = {
  /**
   * Used to perform fetches and invoke errors if something fails.
   * @param {String} url - Endpoint or custom URL
   * @param {Boolean} options.customUrl -  True for full URL instead of endpont definition.
   */
  async get(url, { customUrl = false } = {}) {
    try {
      const res = await superagent.get(customUrl ? url : `${API_URL}${url}`);
      return res.body;
    } catch (err) {
      handleError(err);
      return null;
    }
  },

  async post(url, payload, { customUrl = false } = {}) {
    try {
      const res = await superagent.post(customUrl ? url : `${API_URL}${url}`).send(payload);
      return res.body;
    } catch (err) {
      handleError(err);
      return null;
    }
  },

  async find(url, query) {
    try {
      const queryString = Object.keys(query)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
        .join('&');
      const res = await superagent.get(`${API_URL}${url}`).query(queryString);
      return res.body;
    } catch (err) {
      handleError(err);
      return null;
    }
  },
};

const configurators = {
  async get(configuratorId) {
    return requests.get(`/configurators/${configuratorId}`);
  },
};

const products = {
  async findByConfiguratorId(configuratorId) {
    return requests.find('/products/', { Active: true, 'configurators._id': configuratorId });
  },
  async findById(productId) {
    return requests.get(`/products/${productId}`);
  },
};

const extras = {
  async findByProductId(productId) {
    return requests.find('/extras/', {
      Active: true,
      'products._id': productId,
      _sort: 'Priority:ASC',
    });
  },
  async findById(extraId) {
    return requests.get(`/extras/${extraId}`);
  },
};

const upsells = {
  async findByProductId(productId) {
    return requests.find('/upsells/', {
      Active: true,
      'products._id': productId,
      _sort: 'Priority:ASC',
    });
  },
  async findById(upsellId) {
    return requests.get(`/upsells/${upsellId}`);
  },
};

const testimonials = {
  async all() {
    return requests.get('/testimonials/');
  },
};

const orders = {
  async post(payload) {
    return requests.post('/orders/', {
      ...payload,
    });
  },
};

const menus = {
  /**
   * Get menu from WordPress-API on same host (yes, I'm lazy).
   * Todo: Maybe find a better solution (prefered backend solotion) for this issue.
   * Attention: If we want to host this app elsewhere, we need some kind of domain mapping here.
   */
  async get() {
    if (process.env.NODE_ENV === 'production') {
      return requests.get(`https://${window.location.hostname}/wp-json/menus/v1/menus/hauptmenue`, {
        customUrl: true,
      });
    }
    return requests.get(`${process.env.VUE_APP_WP_ROOT}/wp-json/menus/v1/menus/hauptmenue`, {
      customUrl: true,
    });
  },
};

export { configurators, products, extras, upsells, testimonials, orders, menus };
